import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Archivos de traducción
import esTranslations from './locales/es.json';
import enTranslations from './locales/en.json';
import itTranslations from './locales/it.json';
import ptTranslations from './locales/pt.json';

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    debug: false,
    fallbackLng: 'es',
    interpolation: {
      escapeValue: false
    },
    resources: {
      es: {
        translation: esTranslations
      },
      en: {
        translation: enTranslations
      },
      it: {
        translation: itTranslations
      },
      pt: {
        translation: ptTranslations
      }
    },
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    }
  });

export default i18n; 